export default {
    LOAD_PRODUCTFILES (state, productfiles) {
        state.items = productfiles
    },
    LOAD_FILES_BY_PRODUCT (state, productfiles) {
        state.arquivos = productfiles
    }
}